import { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";

const CompareCtx = createContext(null);
const KEY = "cfpv_compare";
const MAX = 6;

export function CompareProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });
  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);

  const has = (type, id) => items.some((i) => i.type === type && i.id === id);
  const toggle = (item) => {
    if (has(item.type, item.id)) {
      setItems((s) => s.filter((i) => !(i.type === item.type && i.id === item.id)));
      return;
    }
    if (items.length >= MAX) { toast.error(`En fazla ${MAX} ürün karşılaştırılabilir`); return; }
    setItems((s) => [...s, item]);
    toast.success("Karşılaştırmaya eklendi");
  };
  const clear = () => setItems([]);
  const remove = (type, id) => setItems((s) => s.filter((i) => !(i.type === type && i.id === id)));

  return <CompareCtx.Provider value={{ items, has, toggle, clear, remove, setItems }}>{children}</CompareCtx.Provider>;
}

export const useCompare = () => useContext(CompareCtx);
